import React from 'react';
import {useAttributeSetSelectionProvider} from '@netx/core-attribute-set-selection/context';
// TODO: address the fact that a container is expecting to be wrapped by a context that is expecting to be wrapped by this module's context
// This information can be handled elsewhere (or this is a container in selection module)
import SortableAttributeSets, {
	SortableAttributeSetsProps,
} from '../../components/SortableSets';

export type SortableAttributeSetsContainerProps = Partial<
	Omit<
		SortableAttributeSetsProps,
		'sets' | 'attributeTemplates' | 'lookupsAllowed' | 'orderUpdated'
	>
> & {
	// inputForm: any;
};

export const SortableAttributeSetsContainer = (
	props: SortableAttributeSetsContainerProps,
) => {
	const attributeSetSelection = useAttributeSetSelectionProvider();
	return (
		<SortableAttributeSets
			sets={attributeSetSelection.attributeSetCtx.getByIds(
				attributeSetSelection.selected,
			)}
			attributeTemplates={attributeSetSelection.attributeTemplates}
			setsLoaded={attributeSetSelection.loadedSets}
			enforce={attributeSetSelection.enforce}
			ids={attributeSetSelection.selected}
			lookupsAllowed={attributeSetSelection.lookupsAllowed}
			orderUpdated={attributeSetSelection.setOrder}
			{...props}
		/>
	);
};

export default SortableAttributeSetsContainer;
